var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeComponent2',{attrs:{"title":_vm.title,"message":_vm.message,"ignore":_vm.ignore,"order":_vm.order,"custom":_vm.custom}})
}
var staticRenderFns = []

export { render, staticRenderFns }